<template>
  <el-dialog :title= "isAdd?'新增智能柜':'智能柜维护'"  :visible.sync="dialogFormVisible" :before-close="close" :close-on-click-modal = false>
    <el-form :model="form" :rules="rules" ref="form" label-width="100px">
      <el-form-item label="柜子编号" :label-width="formLabelWidth" prop="CABINET_ID">
        <el-input v-model="form.CABINET_ID"></el-input>
      </el-form-item>
      <el-form-item label="所属智能称" :label-width="formLabelWidth" prop="EQUIP_ID">
        <el-select v-model="form.EQUIP_ID" placeholder="请选择所属智能称">
          <el-option
                  v-for="(item, key) of equitList"
                  :key="key"
                  :label="item.EQUIP_ID"
                  :value="item.EQUIP_ID">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="柜子类型" :label-width="formLabelWidth" prop="CABITYPE_ID">
        <el-select v-model="form.CABITYPE_ID" placeholder="请选择柜子类型">
          <el-option
                  v-for="(item, key) of cabinetList"
                  :key="key"
                  :label="item.CABITYPE"

                  :value="item.CABITYPE_ID">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="在线状态" :label-width="formLabelWidth" prop="ONLINE_STATUS">
        <el-select v-model="form.ONLINE_STATUS" placeholder="请选择">
          <el-option label="在线" value="1"></el-option>
          <el-option label="离线" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="湿度" :label-width="formLabelWidth" prop="HUMIDITY">
        <el-input v-model="form.HUMIDITY"></el-input>
      </el-form-item>
      <el-form-item label="温度" :label-width="formLabelWidth" prop="TEMPERATURE">
        <el-input v-model="form.TEMPERATURE"></el-input>
      </el-form-item>
      <el-form-item label="备注" :label-width="formLabelWidth" prop="COMMENTS">
        <el-input v-model="form.COMMENTS"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="makeSure('form')">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script type="text/ecmascript-6">
import cabinetSet from 'api/Management/cabinetSet.js'
const _cabinetSet = new cabinetSet()
const baseForm = {
    CABINET_ID: '',
    EQUIP_ID: '',
    CABITYPE: '',
    ONLINE_STATUS: '',
    HUMIDITY: '',
    TEMPERATURE: '',
    COMMENTS:'',


}

export default {
  props: {
    dialogFormVisible: Boolean,
      ruleForm: Object,
    SEQ_NO:String
  },
  data() {
    let  validateNumber = (rule, value, callback) => {
     let reg = /^(?:0|[1-9]?|9)$/
      if (value =='') {
        callback(new Error('请输入柜子编号'))
      } else if( !reg.test(value)){
        callback(new Error('请输入1-9的整数'))
      }else {
        callback()
      }
    }
    return {
      form: baseForm,
      formLabelWidth: '120px',
      formData:[],
      userList:[],
      isAdd: true,
      cabinetList:[],
      equitList:[],
      rules: {
        CABINET_ID: [
          { required: true, validator: validateNumber, trigger: 'blur' }
        ],
      }
    }
  },
  mounted(){
      this.getCabinetList()
      this.getSmall()
  },
  methods: {
      async submitForm() {
          this.cabinetList.forEach(item=>{

             if(item.CABITYPE_ID === this.form.CABITYPE_ID){
                 this.form.CABITYPE = item.CABITYPE
             }
          })
          if(this.isAdd){
            _cabinetSet.CabinetCreate(this.form.CABITYPE,this.form.CABINET_ID,this.form.CABITYPE_ID,this.form.COMMENTS,this.form.EQUIP_ID,this.form.HUMIDITY,this.form.ONLINE_STATUS,this.form.TEMPERATURE)
                .then(res => {
                    this.$message({
                        message: '新增成功！',
                        type: 'success'
                    })
                }).catch((err)=>{
              this.$message.error('新增失败')
            })
          }else {
              _cabinetSet.CabinetUpdate(this.form.CABITYPE,this.form.CABINET_ID,this.form.CABITYPE_ID,this.form.COMMENTS,this.form.EQUIP_ID,this.form.HUMIDITY,this.form.ONLINE_STATUS,this.SEQ_NO,this.form.TEMPERATURE)
                  .then(res => {
                      this.$message({
                          message: '编辑成功！',
                          type: 'success'
                      })
                  }).catch((err)=>{
                this.$message.error('编辑失败')
              })
          }


      this.close()
    },
    makeSure(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitForm()
          this.$emit('getCabinetList')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    close() {
      this.$emit('controlFormWindow', false)
    },
    //   获取柜子类型
    getCabinetList(){
        let list = 'all'
        _cabinetSet.getCabinet(5000,1,list).then(res=>{
            this.cabinetList = res.items

        })
    },
  //    获取所属智能称
    getSmall(){
        let list = 'all'
        _cabinetSet.getSmall(5000,1,list).then(res=>{
            this.equitList = res.items

        })
    },

  },
  components: {

  },
    watch: {
        ruleForm(newVal) {
            if (Object.keys(newVal).length > 0) {
                this.form = newVal
                this.isAdd = false
            }else {
                this.isAdd = true
                this.form = {
                    CABINET_ID: '',
                    EQUIP_ID: '',
                    CABITYPE: '',
                    ONLINE_STATUS: '',
                    HUMIDITY: '',
                    TEMPERATURE: '',
                    COMMENTS: ''
                }
            }
        }
    }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">

</style>
